// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".page-layout {\n  margin: 10px;\n}\n", "",{"version":3,"sources":["C:\\work\\takeda\\ui\\takeda_front\\src\\component\\layout\\src\\index.less","index.less"],"names":[],"mappings":"AAAA;EACI,YAAA;ACCJ","file":"index.less","sourcesContent":[".page-layout {\n    margin: 10px;\n}",".page-layout {\n  margin: 10px;\n}\n"]}]);
// Exports
module.exports = exports;
